
export default {
  valueType: 'digit',
  FormItemProps: {
    label: '数字输入框',
    rules: [],
    style: {}
  },
  ControlProps: {
    prefix: "", // 带有前缀图标的 input
    disabled: false,
    min: null,
    max: null,
    placeholder: "",
    style: {}
  },
}

